export default "__VITE_ASSET__C4hqUVYJ__"